import React from 'react'

const Error = () => {
  return (
    <main>
        <div className="container py-5">
            <p>Sorry, we cannot process your request right now, Please contact {process.env.REACT_APP_SUPPORT_EMAIL}</p>
        </div>
    </main>
  )
}

export default Error